<script lang="ts">
  import type {ITransactionProgress} from "$lib/interfaces/ITransactionProgress";
  import OrderProgressItem from "$lib/components/TransactionDetails/OrderProgress/OrderProgressItem.svelte";

  interface Props {
    progresses: ITransactionProgress[];
  }

  let { progresses }: Props = $props();
</script>

<div class="w-full flex flex-col items-start justify-start mt-4">
  <h3 class="text-lg font-semibold">Order Progress</h3>
  <div class="flex flex-col items-start space-y-4 mt-4 w-full">
    {#each progresses as progress}
      <OrderProgressItem progress={progress} />
    {/each}
  </div>
</div>